import * as React from 'react';
import * as Loadable from 'react-loadable';
import { LoadingSpinner } from '@common/components';

export const AsyncTransactionLanding = Loadable({
  loader: () => import(/* webpackChunkName: "TransactionModule" */ 'src/transaction').then(m => m.TransactionLanding),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});



// WEBPACK FOOTER //
// ./src/_Modules/transaction.module.tsx